import { showDemoDataSelectors } from '@/redux/selectors';
import { useAppSelector } from '@/redux/hooks';

import { Stats } from './components/Stats';
import { Entity } from './components/Entity';
import { ThisIsDemoData } from '../../ThisIsDemoData';

const Customers = () => {
  const isShowDemoData = useAppSelector(showDemoDataSelectors.byCompliance);

  return (
    <>
      {isShowDemoData && <ThisIsDemoData />}
      <Stats />
      <Entity />
    </>
  );
};

export default Customers;
